import { Rating } from './types';

class RatingHelper {
  static toReal(rating: number) {
    return rating / 2;
  }

  static toRounded(rating: number, nrOfDecimals = 1) {
    return parseFloat(RatingHelper.toReal(rating).toFixed(nrOfDecimals));
  }

  static toRoundedString(rating: number, nrOfDecimals = 1) {
    return RatingHelper.toReal(rating).toFixed(nrOfDecimals);
  }

  static toHalf(rating: number) {
    return Math.ceil(RatingHelper.toRounded(rating) * 2) / 2;
  }

  static toWhole(rating: number) {
    return Math.round(RatingHelper.toHalf(rating));
  }

  static convert(rating: number, nrOfDecimals = 1): Rating {
    return {
      real: RatingHelper.toReal(rating),
      rounded: RatingHelper.toRounded(rating, nrOfDecimals),
      roundedString: RatingHelper.toRoundedString(rating, nrOfDecimals),
      half: RatingHelper.toHalf(rating),
      whole: RatingHelper.toWhole(rating),
    };
  }
}

export default RatingHelper;
